/**
 * `pageContext()`
 *
 * Returns page-context object from Django
 *
 */

const errorReporter = require('../error-reporting')
let cachedContext = null

module.exports = pageContext

function pageContext(ignoreCache = false) {
  if (!ignoreCache && cachedContext) return cachedContext

  const el = document.getElementById('js-page-context')

  if (!el) {
    cachedContext = {}
    return cachedContext
  }

  const json = el.innerText.trim()

  try {
    cachedContext = JSON.parse(JSON.parse(json))
    return cachedContext
  } catch (e) {
    errorReporter(e, __filename)

    throw e
  }
}
